<template lang="pug">
  .warningBox(v-if="config.text && config.promoCode")
    p.warningBox__text {{ config.text }}
    p.warningBox__cupom Cupom: #[strong {{ config.promoCode }}]
</template>
<script>
export default {
  name: 'WarningBox',
  props: {
    config: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/style/_variables";

  .warningBox {
    background-color: #f5f7fa;
    border-radius: 8px;
    border: solid 1px rgba(#bdc2c6, .4);
    color: #595959;
    font-family: $rubik-font-family;
    font-size: 14px;
    text-align: center;
    padding: 16px 26px;

    &__text {
      font-size: 14px;
      line-height: 1.43;
    }

    &__cupom {
      font-family: $oscine-font-family;
      font-size: 20px;
      color: #444444;
      margin-top: 8px;
    }
  }
</style>
